<template>
  <div class="teacher-list">
    <div class="teacher-list-alert">
      请在<span class="whole">左边已上传的教师列表</span>中选择<span class="teacher">需要与该班级绑定的教师</span>添加到<span class="bound">右边与{{
        currentGradeItem.gradeName
        }}{{ currentClassItem.className }}绑定的教师列表</span>中
    </div>
    <div class="teacher-list-inner-wrapper">
      <div class="whole-teacher-list-container teacher-list-container" v-loading="wholeTeacherListLodaing">
        <div class="teacher-list-top-bar whole-label">
          <span class="label-text">已上传的教师列表</span>
          <div class="teacher-search">
            <input type="text" class="search-input" placeholder="输入名字搜索教师" v-model="searchKeyWord"
              @input="searchContentChange" @keydown.enter="searchTeacherByKeyWord" />
            <button class="search-button" @click="searchTeacherByKeyWord">确认</button>
          </div>
        </div>
        <div class="teacher-list-wrapper whole-list">
          <el-table :data="wholeTeacherList" stripe style="width: 100%" max-height="288">
            <el-table-column prop="teacherNumber" label="教师工号" width="120">
            </el-table-column>
            <el-table-column prop="teacherName" label="教师姓名" width="120">
            </el-table-column>
            <el-table-column prop="phone" label="手机号码" width="120"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <div class="add-button-wrapper">
                  <button class="add-button add-subject-teacher"
                    :disabled="isAddSubjectTeacherButtonDisabled(scope.row.id) || !userPermissions.includes('sc:classteacher:bind')"
                    :class="{
                      'add-subject-teacher-button-disabled': isAddSubjectTeacherButtonDisabled(
                        scope.row.id
                      ),
                    }" @click="clickAddTeacher(scope.row, 'subject')">
                    添加为科任老师
                  </button>
                  <button class="add-button add-head-teacher"
                    :disabled="isAddHeadTeacherButtonDisabled(scope.row.id) || !userPermissions.includes('sc:classteacher:bind')"
                    :class="{
                      'add-head-teacher-button-disabled': isAddHeadTeacherButtonDisabled(
                        scope.row.id
                      ),
                    }" @click="clickAddTeacher(scope.row, 'head')">
                    添加为班主任
                  </button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="teacher-list-pagination">
          <el-pagination background layout="prev, pager, next" :total="wholeTeacherListTotal" small
            :page-size="pageSize" :page-num="pageNum" @current-change="handleCurrentChange">
          </el-pagination>
        </div>
      </div>
      <div class="bound-teacher-list-container teacher-list-container" v-loading="boundTeacherListLoading">
        <div class="teacher-list-top-bar bound-label">
          <span class="label-text">与{{ currentGradeItem.gradeName
          }}{{ currentClassItem.className }}绑定的教师列表</span>
        </div>
        <div class="teacher-list-wrapper">
          <div class="bound-teacher-box">
            <div class="bound-teacher-label">班主任</div>
            <div class="teacher-list-inner-container">
              <el-tag class="teacher-item" v-for="(item, index) in boundTeacherList" :key="index" size="small" closable
                effect="dark" v-show="item.isCharge == 1" @close="boundTeacherItemDelete(item, index)">{{
                  item.teacherName +
                "," + item.teacherNumber }}</el-tag>
              <el-tag class="teacher-item" v-for="(item, index) in addTeacherList" :key="item.id" size="small"
                @close="bindingTeacherItemClose(index)" closable v-show="item.isCharge == 1">{{ item.teacherName + "," +
                  item.teacherNumber }}</el-tag>
              <div class="not-added-alert" v-show="isShowUnboundHeadTeacherAlert">
                未添加绑定班主任
              </div>
            </div>
            <div class="bound-teacher-label">科任老师</div>
            <div class="teacher-list-inner-container">
              <el-tag class="teacher-item" v-for="(item, index) in boundTeacherList" :key="index" size="small" closable
                effect="dark" v-show="item.isCharge == 0" @close="boundTeacherItemDelete(item, index)">{{
                  item.teacherName +
                "," + item.teacherNumber }}</el-tag>
              <el-tag class="teacher-item" v-for="(item, index) in addTeacherList" :key="item.id" size="small" closable
                @close="bindingTeacherItemClose(index)" v-show="item.isCharge == 0">{{ item.teacherName + "," +
                  item.teacherNumber }}</el-tag>
              <div class="not-added-alert" v-show="isShowUnboundSubjectTeacherAlert">
                未添加绑定科任老师
              </div>
            </div>
          </div>
        </div>
        <div class="confirm-add">
          <button class="confirm-button" :class="{
            'confirm-add-button-disabled': addTeacherList.length == 0,
          }" :disabled="addTeacherList.length == 0" @click="confirmbindTeacher" v-hasPermi="'sc:classteacher:bind'">
            确认添加
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pageSize: 10,
      pageNum: 1,
      searchKeyWord: "",
      wholeTeacherListTotal: 0,
      wholeTeacherListLodaing: false,
      boundTeacherListLoading: false,
      boundTeacherList: [],
      addTeacherList: [],
      colorList: ["", "success", "info", "warning"],
      wholeTeacherList: [],
      userPermissions: []
    };
  },
  props: {
    isEditTeacherListDialogShow: {
      type: Boolean,
    },
    currentClassItem: {
      type: Object,
      require: true,
    },
    currentGradeItem: {
      type: Object,
      require: true,
    },
  },
  computed: {
    isShowUnboundHeadTeacherAlert() {
      const teacherList = [...this.boundTeacherList, ...this.addTeacherList];
      for (let item of teacherList) {
        if (item.isCharge == "1") {
          return false;
        }
      }
      return true;
    },
    isShowUnboundSubjectTeacherAlert() {
      const teacherList = [...this.boundTeacherList, ...this.addTeacherList];
      for (let item of teacherList) {
        if (item.isCharge == "0") {
          return false;
        }
      }
      return true;
    },
    isAddSubjectTeacherButtonDisabled() {
      const teacherList = [...this.boundTeacherList, ...this.addTeacherList];
      return (teacherId) => {
        for (let item of teacherList) {
          if (teacherId == item.teacherId && item.isCharge == "0") {
            return true;
          }
        }
        return false;
      };
    },
    isAddHeadTeacherButtonDisabled() {
      const teacherList = [...this.boundTeacherList, ...this.addTeacherList];
      return (teacherId) => {
        for (let item of teacherList) {
          if (teacherId == item.teacherId) {
            return true;
          } else if (item.isCharge == 1) {
            return true;
          }
        }
        return false;
      };
    },
  },
  mounted() {
    this.userPermissions = window.localStorage.getItem("menuPermissions");
    this.getWholeTeacherList();
    this.getBoundTeacherList();
    // console.log("classInfo", this.currentClassItem);
  },
  methods: {
    getWholeTeacherList() {
      this.wholeTeacherListLodaing = true;
      this.post(this.$url.selectTeacherListByAdminPC, {
        schoolId: this.school.id,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        teacherName: this.searchKeyWord,
      })
        .then((res) => {
          this.wholeTeacherListLodaing = false;
          // console.log(res);
          if (res.code != 200) {
            return this.$messgae.error("获取教师列表失败");
          }
          this.wholeTeacherListTotal = res.total;
          this.wholeTeacherList = res.rows;
        })
        .catch((err) => {
          this.wholeTeacherListLodaing = false;
          this.$messgae.error("获取教师列表失败");
        });
    },
    handleCurrentChange(e) {
      this.pageNum = e;
      this.getWholeTeacherList();
    },
    searchTeacherByKeyWord() {
      this.pageNum = 1;
      this.getWholeTeacherList();
    },
    searchContentChange() {
      if (this.searchKeyWord.length == 0) {
        // console.log('清空了')
      }
    },
    getBoundTeacherList() {
      this.boundTeacherListLoading = true;
      this.get(this.$url.selectTeacherClassList, {
        classId: this.currentClassItem.classId,
      })
        .then((res) => {
          this.boundTeacherListLoading = false;
          if (res.code != 200) {
            return this.$messgae.error("获取已绑定的教师列表失败");
          }
          this.boundTeacherList = res.data;
        })
        .catch((err) => {
          this.boundTeacherListLoading = false;
          this.$messgae.error("获取已绑定的教师列表失败");
        });
    },
    beforeCloseEditTeacherDialog() {
      this.$emit("beforeCloseEditTeacherDialog");
    },
    boundTeacherItemDelete(teacherInfo, teacherItemIndex) {
      this.$confirm(
        `是否删除${teacherInfo.teacherName}与${this.currentClassItem.className}的绑定关系?`,
        "删除教师班级绑定关系",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.confirmDeleteBoundTeacherCallBack(teacherInfo, teacherItemIndex);
        })
        .catch(() => { });
    },
    confirmDeleteBoundTeacherCallBack(teacherInfo, teacherItemIndex) {
      this.boundTeacherListLoading = true;
      this.delete(
        `${this.$url.deleteClassteacher}/${this.currentClassItem.classId}/${teacherInfo.teacherId}`
      )
        .then((res) => {
          this.boundTeacherListLoading = false;
          if (res.code != 200) {
            return this.$message.error(res.msg);
          }
          this.$message.success("删除班级教师绑定关系成功");
          this.boundTeacherList.splice(teacherItemIndex, 1);
        })
        .catch((err) => {
          this.boundTeacherListLoading = false;
          this.$message.error("删除班级教师绑定关系失败");
        });
    },
    bindingTeacherItemClose(teacherItemIndex) {
      this.addTeacherList.splice(teacherItemIndex, 1);
    },
    clickAddTeacher(teacherInfo, role) {
      this.addTeacherList.push({
        teacherName: teacherInfo.teacherName,
        teacherNumber: teacherInfo.teacherNumber,
        teacherId: teacherInfo.id,
        isCharge: role == "head" ? "1" : "0",
      });
    },
    confirmbindTeacher() {
      this.boundTeacherListLoading = true;
      let confirmBindTeacherList = [];
      this.addTeacherList.forEach((item) => {
        confirmBindTeacherList.push({
          createBy: this.user.id,
          schoolId: this.school.id,
          schoolName: this.school.schoolName,
          gradeId: this.currentGradeItem.gradeId,
          gradeCode: this.currentGradeItem.gradeCode,
          gradeName: this.currentGradeItem.gradeName,
          classId: this.currentClassItem.classId,
          classCode: this.currentClassItem.classCode,
          className: this.currentClassItem.className,
          teacherId: item.teacherId,
          teacherNumber: item.teacherNumber,
          teacherName: item.teacherName,
          isCharge: item.isCharge,
        });
      });
      this.post(this.$url.classteacherAdd, confirmBindTeacherList)
        .then((res) => {
          this.boundTeacherListLoading = false;
          if (res.code != 200) {
            return this.$message.error("添加绑定教师失败");
          }
          this.boundTeacherList.push(...this.addTeacherList);
          this.addTeacherList = [];
          this.$message.success("添加成功");
        })
        .catch((err) => {
          this.boundTeacherListLoading = false;
          this.$message.error("添加绑定教师失败");
        });
    },
  },
};
</script>

<style scoped lang="scss">
@import "./grademanagement-teacherlist.scss";
</style>
